import { render, staticRenderFns } from "./homeDown.vue?vue&type=template&id=5a04ee5e"
import script from "./homeDown.vue?vue&type=script&lang=js"
export * from "./homeDown.vue?vue&type=script&lang=js"
import style0 from "./homeDown.vue?vue&type=style&index=0&id=5a04ee5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports